<template>
  <div>
    <el-container class="contenBox">
      <el-header>
        <Header @collapsemenu="collapsemenu" :flag="0" :collapse="collapse" />
      </el-header>
      <el-container>
        <el-aside width="auto">
          <el-col>
            <el-menu :default-active="activeMenu" background-color="#f2f4f5" text-color="#333333"
              active-text-color="#666666" :collapse="collapse" collapse-transition class="el-menu-vertical-demo"
              unique-opened router @click.native.stop>
              <!-- 普通机构菜单 -->
              <div v-if="jgzl == '0'">
                <!-- 机构信息模块 -->
                <el-menu-item index="/mechanism/registrationApplication">
                  <span class="menuitem_line"></span>
                  <i class="icon-name">
                    <img src="@/assets/images/enterprise_ user_icon.png" width="25px" height="25px" />
                  </i>
                  <span slot="title">入驻申请</span>
                </el-menu-item>
                <!-- 我的服务模块 -->
                <el-menu-item index="/mechanism/myService">
                  <span class="menuitem_line"></span>
                  <i class="icon-name">
                    <img src="@/assets/images/myService.png" width="25px" height="25px" />
                  </i>
                  <span slot="title">服务列表</span>
                </el-menu-item>
                <!-- 企业兑付 -->
                <el-menu-item index="/mechanism/enterpriseExchangeList">
                  <span class="menuitem_line"></span>
                  <i class="icon-name">
                    <img src="@/assets/images/enterprise_ redemption_icon.png" width="25px" height="25px" />
                  </i>
                  <span slot="title">企业兑付</span>
                </el-menu-item>                     
              </div>
              <!-- 一级机构菜单 -->
              <div v-if="jgzl == '1'">
                <!-- 1、机构信息 -->
                <el-menu-item index="/mechanism/mechanismInfomation">
                  <span class="menuitem_line"></span>
                  <i class="icon-name">
                    <img src="@/assets/images/enterprise_ user_icon.png" width="25px" height="25px" />
                  </i>
                  <span slot="title">机构信息</span>
                </el-menu-item>
                <!-- 2、机构管理 -->
                <el-menu-item index="/mechanism/secondaryManagement" v-if="isFullData">
                  <span class="menuitem_line"></span>
                  <i class="icon-name">
                    <img src="@/assets/images/enterprise_ center_icon.png" width="25px" height="25px" />
                  </i>
                  <span slot="title">机构管理</span>
                </el-menu-item>
                <!-- 3、机构服务 -->
                <el-menu-item index="/mechanism/secondaryJgServiceManagement" v-if="isFullData">
                  <span class="menuitem_line"></span>
                  <i class="icon-name">
                    <img src="@/assets/images/myService.png" width="25px" height="25px" />
                  </i>
                  <span slot="title">机构服务</span>
                </el-menu-item>
                <!-- 企业兑付 -->
                <el-menu-item index="/mechanism/enterpriseExchangeList" v-if="isFullData">
                  <span class="menuitem_line"></span>
                  <i class="icon-name">
                    <img src="@/assets/images/enterprise_ redemption_icon.png" width="25px" height="25px" />
                  </i>
                  <span slot="title">企业兑付</span>
                </el-menu-item>                
              </div>
              <!-- 二级机构菜单 -->
              <div v-if="jgzl == '2'">
                <!-- 机构备案菜单 -->
                <el-menu-item index="/mechanism/mechanismInfomation">
                  <span class="menuitem_line"></span>
                  <i class="icon-name">
                    <img src="@/assets/images/enterprise_ user_icon.png" width="25px" height="25px" />
                  </i>
                  <span slot="title">机构备案</span>
                </el-menu-item>
                <!-- 服务发布员资格备案菜单 -->
                <!-- <el-menu-item index="/mechanism/threeManagement" v-if="secondJgShzt === '009'">
                  <span class="menuitem_line"></span>
                  <i class="icon-name">
                    <img src="@/assets/images/enterprise_ center_icon.png" width="25px" height="25px" />

                  </i>
                  <span slot="title">服务发布员资格备案</span>
                </el-menu-item> -->
                <!-- 备案记录菜单 -->
                <el-menu-item index="/mechanism/secondRegistrationApplication">
                  <span class="menuitem_line"></span>
                  <i class="icon-name">
                    <img src="@/assets/images/enterprise_ redemption_icon.png" width="25px" height="25px" />
                  </i>
                  <span slot="title">备案记录</span>
                </el-menu-item>
                <!-- 我的服务菜单 -->
                <el-menu-item index="/mechanism/myService" v-if="secondJgShzt === '009'">
                  <span class="menuitem_line"></span>
                  <i class="icon-name">
                    <img src="@/assets/images/myService.png" width="25px" height="25px" />
                  </i>
                  <span slot="title">我的服务</span>
                </el-menu-item>
                <!-- 企业兑付 -->
                <el-menu-item index="/mechanism/enterpriseExchangeList" v-if="secondJgShzt === '009'">
                  <span class="menuitem_line"></span>
                  <i class="icon-name">
                    <img src="@/assets/images/enterprise_ redemption_icon.png" width="25px" height="25px" />
                  </i>
                  <span slot="title">企业兑付</span>
                </el-menu-item>       
                <!-- <el-submenu index="1" v-if="false">
                  <template slot="title">
                    <span class="menuitem_line"></span>
                    <i class="icon-name">
                      <img src="@/assets/images/enterprise_ user_icon.png" width="25px" height="25px" />
                    </i>
                    <span>机构信息</span>
                  </template>
                  <el-menu-item index="/mechanism/mechanismInfomation">机构备案</el-menu-item>
                  <el-menu-item index="/mechanism/threeManagement" v-if="isFullData">服务发布员资格备案</el-menu-item>
                  <el-menu-item index="/mechanism/secondRegistrationApplication" v-if="jgzl == '2' && isFullData">备案记录</el-menu-item>
                </el-submenu>
                <el-submenu index="2" v-if="false">
                  <template slot="title">
                    <span class="menuitem_line"></span>
                    <i class="icon-name">
                      <img src="../../assets/images/myService.png" width="25px" height="25px" />
                    </i>
                    <span>我的服务</span>
                  </template>
                  <el-menu-item index="/mechanism/myService" v-if="isFullData">服务列表</el-menu-item>
                </el-submenu> -->
              </div>
              <!-- 机构信息 -->
              <!-- <el-menu-item index="/mechanism/mechanismInfomation" v-if="false">
                <span class="menuitem_line"></span>
                <i class="icon-name">
                  <img src="@/assets/images/enterprise_ user_icon.png" width="25px" height="25px" />
                </i>
                <span slot="title">{{ jgzl == '2' ? '机构备案' : '机构信息' }} </span>
              </el-menu-item> -->
              <!-- 机构管理 -->
              <!-- <el-submenu index="1" v-if="false">
                <template slot="title">
                  <span class="menuitem_line"></span>
                  <i class="icon-name">
                    <img src="@/assets/images/enterprise_ center_icon.png" width="25px" height="25px" />
                  </i>
                  <span>机构管理</span>
                </template>
                <el-menu-item index="/mechanism/secondaryManagement"
                  v-if="jgzl == '1' && isFullData">二级机构管理</el-menu-item>
                <el-menu-item index="/mechanism/threeManagement"
                  v-if="jgzl == '2' && isFullData">服务发布员资格备案</el-menu-item>
                <el-menu-item index="/mechanism/registrationApplication"
                  v-if="jgzl != '1' && jgzl != '2'">入驻申请</el-menu-item>
                <el-menu-item index="/mechanism/secondRegistrationApplication" v-if="jgzl == '2'">备案记录</el-menu-item>
              </el-submenu> -->
              <!-- 机构服务 -->
              <!-- <el-submenu index="2" v-if="false">
                <template slot="title">
                  <span class="menuitem_line"></span>
                  <i class="icon-name">
                    <img src="../../assets/images/myService.png" width="25px" height="25px" />
                  </i>
                  <span>机构服务</span>
                </template>
                <el-menu-item index="/mechanism/secondaryJgServiceManagement"
                  v-if="jgzl == '1' && isFullData">二级机构服务</el-menu-item>
                <el-menu-item index="/mechanism/myService" v-if="isFullData && jgzl != '1'">服务列表</el-menu-item>
              </el-submenu> -->
              <!-- 我的服务 -->
              <!-- <el-submenu index="/" v-if="isFullData && jgzl != '1'">
                <template slot="title">
                  <span class="menuitem_line"></span>
                  <i class="icon-name">
                    <img src="../../assets/images/myService.png" width="25px" height="25px" />
                  </i>
                  <span>我的服务</span>
                </template>
                <el-menu-item index="/mechanism/myService">服务列表</el-menu-item>
              </el-submenu> -->
              <!-- 预兑材料 -->
              <!-- <el-submenu index="3" v-if="false">
                <template slot="title">
                  <span class="menuitem_line"></span>
                  <i class="icon-name">
                    <img src="../../assets/images/enterprise_ redemption_icon.png" width="25px" height="25px" />
                  </i>
                  <span>预兑材料</span>
                </template>
                <el-menu-item index="/mechanism/advancePayment">材料情况</el-menu-item>
              </el-submenu> -->
              <!-- 企业兑付 -->
              <!-- <el-submenu index="4" v-if="false">
                <template slot="title">
                  <span class="menuitem_line"></span>
                  <i class="icon-name">
                    <img src="../../assets/images/enterprise_ collection_icon.png" width="25px" height="25px" />
                  </i>
                  <span>企业兑付</span>
                </template>
                <el-menu-item index="/mechanism/corporateRedemption">兑付列表</el-menu-item>
              </el-submenu> -->
              <!-- 我的收藏 -->
              <!-- <el-submenu index="5" v-if="false">
                <template slot="title">
                  <span class="menuitem_line"></span>
                  <i class="icon-name">
                    <img src="@/assets/images/enterprise_ collection_icon.png" width="25px" height="25px" />
                  </i>
                  <span>我的收藏</span>
                </template>
                <el-menu-item index="/mechanism/collection">收藏列表</el-menu-item>
              </el-submenu> -->
            </el-menu>
          </el-col>
        </el-aside>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { getIsFullData } from '@/api/mechanism/indexCenter.js'
import Header from '@/components/Header'
import { mapGetters } from 'vuex'
export default {
  components: {
    Header
  },
  computed: {
    ...mapGetters(['jgzl', 'secondJgShzt'])
  },
  data() {
    return {
      // collapse是否折叠
      collapse: false,
      activeMenu: '/mechanism/mechanismInfomation',
      // 机构信息是否完善
      isFullData: false
    }
  },
  created() {
    this.activeMenu = this.$route.path
    // 获取当前用户信息是完善
    this.getIsFullData()
    this.getSecondJgShzt()
  },
  methods: {
    // 点击展开和折叠左侧菜单
    collapsemenu() {
      this.collapse = !this.collapse
    },
    // 获取机构是否完善
    getIsFullData() {
      getIsFullData()
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.isFullData = data
            if (!data) {
              this.$message.warning('机构信息未完善，请先完善信息，再进行其他操作')
              this.$router.push('/mechanism/mechanismInfomation')
            }
          } else {
            this.isFullData = false
            this.$message.error('系统异常，请稍后再试')
          }
        })
        .catch((error) => {
          this.$message.error(error)
        })
    },
    // 获取二级机构审批状态
    getSecondJgShzt() {
      this.$store
        .dispatch('user/getSecondJgInfo')
    }
  },
  watch: {
    '$route.path': {
      handler: function (newPath) {
        this.activeMenu = newPath
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.contenBox {
  box-sizing: border-box;
  // position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.el-header {
  padding: 0 30px 0 26.5px;
  color: #333;
  text-align: center;
  height: 79px !important;
  background: linear-gradient(to right, #3a76f9, #2d6cf9, #2a6af9);
  border: 1px solid #164f8a;
}

.el-aside {
  background: #f2f4f5;
  box-shadow: 0 1px 0 0 #d8d8d8;
  text-align: left;
}

.el-main {
  background-color: #ffffff;
  color: #ffffff;
  text-align: center;
  height: 90vh;
  padding: 10px 30px 20px 31px;
}

/* 加过渡给侧边导航*/
.el-aside {
  transition: width 0.25s;
  -webkit-transition: width 0.25s;
  -moz-transition: width 0.25s;
  -webkit-transition: width 0.25s;
  -o-transition: width 0.25s;
}

.el-menu-item {
  height: 67px;
}

.el-menu-item,
.el-submenu__title {
  span {
    font-weight: 400;
    font-size: 20px;
    line-height: 65px;
  }

  i {
    margin-left: 25px;
    margin-right: 27px;
  }
}

.el-meun .el-submenu.el-submenu__title:hover {
  background-color: #e4ebf6 !important;
}

.el-menu .el-menu-item.is-active {
  background-color: #e4ebf6 !important;

  :nth-child(1) {
    visibility: visible;
  }
}

.el-menu-vertical-demo .el-submenu.is-active.is-opened .el-submenu__title .menuitem_line {
  visibility: visible;
}

.el-submenu__title {
  &:hover {
    background-color: #e4ebf6 !important;
  }
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 309px;
}

::v-deep .el-menu-vertical-demo .el-menu-item {
  padding-left: 0px !important;

  &:hover {
    background-color: #e4ebf6 !important;
  }
}

::v-deep .el-menu-vertical-demo .el-submenu {
  .el-submenu__title {
    padding-left: 0px !important;
    height: 67px;

    &:hover {
      background-color: #e4ebf6 !important;
    }
  }

  .el-menu-item {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 30px;
    width: 280px;
    height: 48px;
    border-radius: 23.51px 0 0 24.49px;
    background: #e4ebf6;
    font-size: 18px;
  }

  &:hover {
    background-color: #e4ebf6 !important;
  }
}

// /* 更改箭头的样式为+和-号 */
::v-deep .el-menu-vertical-demo .el-submenu .el-submenu__title .el-submenu__icon-arrow.el-icon-arrow-down {
  content: url('~@/assets/images/open.png');
  /* 替换展开时的箭头为 + 号 */
  margin-right: 30px;
}

::v-deep .el-menu-vertical-demo .el-submenu.is-opened .el-submenu__title .el-submenu__icon-arrow.el-icon-arrow-down {
  content: url('~@/assets/images/put_away.png');
  /* 替换展开时的箭头为 - 号 */
  margin-right: 30px;
}

// 菜单栏激活时竖线
.menuitem_line {
  display: inline-block;
  width: 10px;
  height: 95%;
  background-color: rgb(79, 126, 247);
  visibility: hidden;
}
</style>
